export default "__VITE_ASSET__bd7a2ba7__"